export const locale = {
  lang: 'es',
  data: {
    'CIERRE': {
      'CARGANDO':'Cargando información',
      'CARGANDOCORREO':'Por favor espere...',
      'LABEL1': 'Encuesta en progreso',
      'LABEL2': 'Ver avance',
      'LABEL3': 'Encuesta completa',
      'LABEL4': 'Ver resultados',
      'LABEL5': 'Recordatorios enviados correctamente',
      'LABEL6': 'Ya has enviado un correo el día de hoy',
      'LABEL7': 'Solo puede enviar recordatorios a partir de la fecha de lanzamiento',
      'LABEL8': 'Espere un momento.....',
      'LABEL9': 'Días restantes',
      'BTN_CIERRE': 'Cerrar ahora',
      'ALERT':{
        'MESSAGE': '¿Confirme realizar el cierre anticipado de la encuesta?',
        'BTN_CONFIRM': 'Sí',
        'BTN_CANCEL': 'No',
        'OK':'OK',
      },
      'ALERT_RE':{
        'MESSAGE': '¿Esta seguro que desea enviar los recordatorios?',
        'BTN_CONFIRM': 'Sí',
        'BTN_CANCEL': 'No',
        'OK':'OK',
      },
      'LINK': 'Ingrese al siguiente enlace para visualizar el progreso actual de la encuesta:',
      'LINKENCUESTA': 'Genere el enlace para visualizar el progreso actual de la encuesta:',
      'ACTIONS':{
        'TITULO': 'Acciones',
        'TITULO_ACTUALIZADO': 'Recordatorios',
        'TITULO_ACCESS': 'Acceso a la encuesta',
        'WANNADO': '¿Qué desea realizar?',
        'TITULO_VIRSMS': 'Portal de SMS virtual',
        'TITULO_MYCODE': 'Portal GetMyCode.culturalgo.com',
        'TITULO_BTNMYCODE': 'Ir al portal de GetMyCode',
      },
      'COMPLETO':{
        'TAG': 'La encuesta ha concluído correctamente',
        'CARDTIT': 'Consulta de resultados',
        'LINK': 'Ingrese al siguiente enlace para visualizar los resultados obtenidos en la encuesta:'
      },
      'PORTAL':{
        'LABEL01':'Portal de conteos',
        'LABEL02':'Generar llave de acceso'
      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO':'Avance de la encuesta',
        'LINKEN': 'Enlace encuesta ',
        'LINKRES': 'Enlace resultado ',
        'ENCUESTANOENVIADA': 'Aún no se ha lanzado ninguna encuesta Pulse Check',
      },
      'CIERRE':{
        'BCONTEOS':'Portal de conteos',
        'BACCESO':'Generar llave de acceso',
        'LINKPORTAL': 'Copiar enlace de acceso a portal de conteos',
        'COPYLINK':'Se copio a su portapapeles',
        'REMANDER':'Recordatorios',
        'REMANDERC2':'Recordatorios a personas que no han finalizado',
        'REMANDER1':'Recordatorios a personas que aún no ingresan a su encuesta',
        'REMANDER2':'Recordatorios a personas que han iniciado y aún no terminan',
        'REMANDER_TURQUIA':'Envíe recordatorios a todos los participantes',
        'GETURLSURV_1': 'Generar enlace de proveedor de acceso a la encuesta',
        'GETURLSURV_2': 'El enlace del sitio para la obtención de la encuesta fue generado, ahora puede copiarlo haciendo clic sobre el mismo botón',
        'GETURLSURV_3': 'Copiar enlace de proveedor de acceso a la encuesta',
        'ASIGUSERDEMO':'Asignando clave',
      },
      'MOD_TEX_SEND_RECO':'Enviando correo electronico...',


    },
  }
};
